export const NotificationCommon = {
  successResetPassword: "メールを送信しました",
  successApplyClient: "登録を完了しました",
  failureApplyClientEmailAlreadyUsed:
    "このメールアドレスはすでに使用されています。別のメールアドレスをご入力ください。",
};

export const NotificationClient = {
  // 成約
  successCreateContract: "成約報告を送信しました",
  successUpdateContract: "成約報告を送信しました",
  successApproveContract: "成約を承認しました",
  // Mypage
  successUpdateCompany: "情報を更新しました",
  successUpdateClient: "情報を更新しました",
  successUpdatePassword: "パスワードを更新しました",
  successUpdateEmail: "メールアドレスを更新しました",
  // Project
  successCreateProject: "募集を作成しました",
  successUpdateProject: "情報を更新しました",
  failureCreateProject:
    "案件を作成できませんでした。案件公開数を確認してください。",
  failureStatusOpenProject:
    "案件を公開設定に変更できませんでした。案件公開数を確認してください。",
  // Scout
  successCreateScout: "スカウトを実行しました",
  failureCreateScout:
    "スカウトを実行できませんでした。プラン上限数を確認してください。",
  // Clients
  successCreateClient:
    "メンバーの追加が完了しました。ログイン情報はメールで通知されます。",
  failureCreateClient:
    "アカウントを作成できませんでした。プラン上限数を確認してください。",
};

export const NotificationCustomer = {
  // Mypage
  successUpdateCustomer: "情報を更新しました",
  successUpdatePassword: "パスワードを更新しました",
  successUpdateEmail: "メールアドレスを更新しました",
  // Project
  successCreateEntry: "エントリーしました",
  // BlackList
  successAddBlackList: "企業ドメインの追加が完了しました。",
  successDeleteBlackList: "企業ドメインの削除が完了しました。",
  // ExternalContract
  successCreateJobCareer: "職務経歴に掲載しました。",

  // Customer
  successCustomerPlan: "お試しプランの利用を開始しました。",
};



// WEBPACK FOOTER //
// ./src/config/view_const/notification.ts